export const iconFontAwesomeCommunicationCommentSlash = (
	<i className="fa-solid fa-comment-slash"></i>
);
